import React, { useEffect, useMemo, useState } from "react";
import { getData } from "../../../../services/library";
import {
  AppBar,
  Container,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import CloseIcon from "@mui/icons-material/Close";

function HistorialRangoPrecios(props) {
  const [historial, setHistorial] = useState();

  const obtenerHistorial = () => {
    const sucursales = localStorage.getItem("suc_auth"); 
    getData(`/envasado_historial_rango/sucauth/${sucursales}`, setHistorial);
  };

  useEffect(() => {
    obtenerHistorial();
  }, []);

  const columns = useMemo(
    () => [
      {
        header: "Sucursal",
        accessorKey: "nombre_sucursal",
        size: 120,
      },
      {
        header: "Producto",
        accessorKey: "nombre_producto",
        size: 150,
      },

      {
        header: "Mínimo",
        columns: [
          {
            header: "Anterior",
            accessorKey: "precio_minimo_anterior",
            size: 100,
          },
          {
            header: "Nuevo",
            accessorKey: "precio_minimo_nuevo",
            size: 100,
          },
        ],
      },
      {
        header: "Máximo",
        columns: [
          {
            header: "Anterior",
            accessorKey: "precio_maximo_anterior",
            size: 100,
          },
          {
            header: "Nuevo",
            accessorKey: "precio_maximo_nuevo",
            size: 100,
          },
        ],
      },

      {
        header: "Actualización",
        accessorKey: "fecha",
        size: 120,
      },
    ],
    [],
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const customLocalization = {
    ...MRT_Localization_ES,
    expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
    expand: "Ex", // Cambia 'Expandir' a 'Ex'
  };

  const initialState = {
    density: "compact",
    pagination: { pageIndex: 0, pageSize: 10 },
    grouping: ["nombre_sucursal"],
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };
  return (
    <>
      <AppBar
        sx={{ position: "relative" }}
        style={{ backgroundColor: "#0979b0" }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => props.onClose()}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Precios Mínimos y Máximos
          </Typography>
        </Toolbar>
      </AppBar>
      <MaterialReactTable
        columns={columns}
        data={historial ?? [{}]}
        layoutMode={"grid"}
        initialState={initialState}
        enableColumnActions={false} //deshabilita las acciones POR COLUMN}
        enableGlobalFilterModes={false}
        enableHiding={false}
        enableGrouping={true}
        enablePinning={true}
        enableColumnFilters={false}
        enableFullScreenToggle={false}
        positionActionsColumn={"last"}
        enableExpandAll={false}
        localization={customLocalization}
        enableToolbarInternalActions={true}
        muiTableHeadCellProps={tableHeadCellProps}
        muiSearchTextFieldProps={muiSearchTextFieldProps}
        enableDensityToggle={false}
        positionToolbarAlertBanner="none"
        muiTableDetailPanelProps={{
          sx: {
            backgroundColor: "white", // Fondo blanco para el panel de detalles
            width: "100%",
          },
        }}
        enableColumnResizing={true}
        muiTableBodyCellProps={({ row }) => ({
          align: "left",
        })}
        renderTopToolbarCustomActions={() => (
          <>
            <Typography variant="poster" fontSize={26}>
              Historial
            </Typography>
          </>
        )}
      />
    </>
  );
}

export default HistorialRangoPrecios;
